import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@sainsburys-tech/bolt'
import { ReportFlagIcon } from '@sainsburys-tech/bolt-icons'
import getCookie from '../../helpers/getCookie'
import setCookie from '../../helpers/setCookie'
import { pushEventAndTrack } from '../../helpers/taggingSerializer'

import * as Styled from './BazaarVoiceHelpfulness.styles'

class BazaarVoiceHelpfulness extends Component {
  constructor(props) {
    super(props)

    this.state = {
      disabled: false,
      reportDisabled: false,
      helpfulCount: props.helpfulCount,
      unhelpfulCount: props.unhelpfulCount
    }
  }

  componentDidMount() {
    this.getCookieValues()
    this.disableButtonsIfCookieSet()
  }

  componentDidUpdate(prevProps) {
    const { contentId, helpfulCount, unhelpfulCount } = this.props

    if (
      contentId !== prevProps.contentId &&
      (helpfulCount !== this.state.helpfulCount || unhelpfulCount !== this.state.unhelpfulCount)
    ) {
      this.setState({ helpfulCount, unhelpfulCount })
    }

    if (contentId !== prevProps.contentId) {
      this.setState({
        disabled: false
      })

      this.getCookieValues()
      this.disableButtonsIfCookieSet()
    }
  }

  getCookieValues = () => {
    const cookieValue = getCookie('BVDisabled')
    this.disabledIds = cookieValue ? cookieValue.split(',').map(val => parseInt(val, 10)) : []

    const cookieValueReported = getCookie('BVReportedIds')
    this.disabledReportedIds = cookieValueReported ? cookieValueReported.split(',').map(val => parseInt(val, 10)) : []
  }

  disableButtonsIfCookieSet = () => {
    if (this.disabledIds.indexOf(this.props.contentId) > -1) {
      this.disableButtonsAndIncrement()
    }
    if (this.disabledReportedIds.indexOf(this.props.contentId) > -1) {
      this.disableReported()
    }
  }

  voteHelpful = event => {
    event.preventDefault()
    this.submitVote('Positive')
    this.setDisabledCookie(true)
  }

  voteUnhelpful = event => {
    event.preventDefault()
    this.submitVote('Negative')
    this.setDisabledCookie(false)
  }

  voteReport = event => {
    event.preventDefault()
    this.submitVote('Report')
    this.setReportedCookie()
  }

  submitVote = vote => {
    this.props.postFeedback({
      vote,
      contentType: this.props.contentType,
      contentId: this.props.contentId
    })
    pushEventAndTrack({
      eventInfo: {
        eventName: 'pdp_reviewsSubmitFeedback',
        eventAction: 'PDP Reviews - Submit Feedbac'
      },
      attributes: {
        feedback: vote,
        starRating: this.props.starRating
      }
    })
  }

  setReportedCookie = () => {
    this.getCookieValues()

    if (this.disabledReportedIds.indexOf(this.props.contentId) < 0) {
      this.disabledReportedIds.push(this.props.contentId)
      setCookie('BVReportedIds', this.disabledReportedIds.join(','))
    }
    this.disableReported()
  }

  disableReported = () => {
    const state = { reportDisabled: true }
    this.setState(state)
  }

  setDisabledCookie = helpful => {
    this.getCookieValues()

    if (this.disabledIds.indexOf(this.props.contentId) < 0) {
      this.disabledIds.push(this.props.contentId)
      setCookie('BVDisabled', this.disabledIds.join(','))
    }

    this.disableButtonsAndIncrement(helpful)
  }

  disableButtonsAndIncrement = helpful => {
    const state = { disabled: true }
    if (helpful) {
      state.helpfulCount = this.state.helpfulCount + 1
    }
    if (helpful === false) {
      state.unhelpfulCount = this.state.unhelpfulCount + 1
    }
    this.setState(state)
  }

  render() {
    return (
      <Styled.Container>
        {!this.state.disabled && (
          <>
            <Button
              onClick={this.voteHelpful}
              disabled={this.state.disabled}
              kind='secondary'
              data-test='helpful-button'
            >
              Helpful ({this.state.helpfulCount})
            </Button>
            <Button
              onClick={this.voteUnhelpful}
              disabled={this.state.disabled}
              kind='secondary'
              data-test='unhelpful-button'
            >
              Unhelpful ({this.state.unhelpfulCount})
            </Button>
          </>
        )}
        {this.state.disabled && <Styled.Grateful>Thank you for giving feedback</Styled.Grateful>}
        {!this.state.reportDisabled && (
          <Styled.ReportButtonContainer>
            <Button
              onClick={this.voteReport}
              disabled={this.state.reportDisabled}
              kind='secondary'
              data-test='report-button'
              aria-label='report'
            >
              <Styled.ReportContents>
                <ReportFlagIcon />
                <Styled.ReportButtonText>Report</Styled.ReportButtonText>
              </Styled.ReportContents>
            </Button>
          </Styled.ReportButtonContainer>
        )}
        {this.state.reportDisabled && <Styled.Grateful>You’ve reported this review</Styled.Grateful>}
      </Styled.Container>
    )
  }
}

BazaarVoiceHelpfulness.propTypes = {
  contentId: PropTypes.number.isRequired,
  contentType: PropTypes.string.isRequired,
  helpfulCount: PropTypes.number.isRequired,
  unhelpfulCount: PropTypes.number.isRequired
}

export default BazaarVoiceHelpfulness
